export default __webpack_public_path__ + "static/media/1.65cea18c.jpg";